<template>
    <div class="page-home">
        <template v-if="fromTemplateId == 99">
            <TemplatePage type="home" />
        </template>
        <template v-else>
            <Header :themeConfig="themeConfig" :fromTemplateId="fromTemplateId" />
            <ScientificResearch v-if="dtBrand === 'gzky'" />
            <Middle
                :templateList="templateList"
                :fromTemplateId="fromTemplateId"
                :dt-brand="dtBrand"
                v-else
            />
            <Footer />
        </template>
    </div>
</template>

<script setup>
import { ref, onBeforeMount, provide } from 'vue';
import Header from './header.vue';
import Middle from './middle.vue';
import Footer from './footer.vue';
import ScientificResearch from '@/views/scientific-research/index.vue';
import TemplatePage from './template/index.vue';

// 模板配置
const templateList = ref([]);
// 门户主题色、导航配置
const themeConfig = ref({});
// 门户模板id
const fromTemplateId = ref('');
const dtBrand = ref('');

provide('themeConfig', themeConfig);

// 获取门户栏目
function getNavContent() {
    G_transmit('getNavContent', {
        name: 'getNavContent',
        queries: {
            client: 'pc',
            componentTypes: 'portalColumn',
        },
    }).then(res => {
        let data = res.data?.portalColumn?.data;
        let resultList = (data && JSON.parse(data)) || [];
        dtBrand.value = res.data?.portalColumn?.dtBrand;
        templateList.value = resultList;
        console.log(templateList.value, 'templateList.value');
        fromTemplateId.value = res.data?.portalColumn?.fromTemplateId || '';

        themeConfig.value = (res.data?.portalColumn?.config &&
            JSON.parse(res.data?.portalColumn?.config)) || {
            'nav-sub-bg-more-color': '#217828d6',
            'nav-sub-bg-active-color': '#A1FF9F',
            'nav-bg-active-color': '#ffffff2e',
            'home-color-bg': '#E9F6EB',
            'home-color-bg-ligter': '#F7F9FA',
            'nav-top-bg-color': '#228340',
            'nav-bottom-bg-color': '#4AB02F',
            'home-main-color': '#279731',
            'home-header-bg': '#D5ECE3',
            'home-border-color': '#D3DCD1',
            'home-main-active-color': '#17771F',
            'home-header-line': '#208242',
            'home-header-line-lighter': '#a9d813',
            bannerUrl:
                'https://srt-read-online.3ren.cn/basebusiness/material/20240407/363ec623022194ffaa6c58e3dda1cdd1.png',
        };
        setStyle();
    });
}

function setStyle() {
    // 判断是否设置了颜色，没有设置的话使用主题色
    let themeColor = themeConfig.value['home-main-color'];
    themeConfig.value = Object.assign(
        {
            // 导航下拉背景色
            'nav-sub-bg-more-color': themeColor,
            // 顶部区域线条渐变色1
            'home-header-line-lighter': themeColor,
            // 顶部区域线条渐变色2
            'home-header-line': themeColor,
            // 导航颜色1
            'nav-top-bg-color': themeColor,
            // 导航颜色2
            'nav-bottom-bg-color': themeColor,
        },
        themeConfig.value,
    );

    let list = Object.keys(themeConfig.value);
    list = list.filter(key => key !== 'bannerUrl');
    list.forEach(key => {
        document
            .getElementsByTagName('body')[0]
            .style.setProperty(`--${key}`, themeConfig.value[key]);
    });
}

onBeforeMount(() => {
    // 获取门户模板配置
    getNavContent();
});
</script>

<style lang="scss" scoped>
.page-home {
    color: #000000;
    font-size: 14px;
    background-color: #ffffff;
    .page-float {
        width: 70px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        position: fixed;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        li {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 14px;
            cursor: pointer;
            &:last-child {
                &::after {
                    content: '';
                    display: none;
                }
            }
            &::after {
                content: '';
                display: inline-block;
                width: 24px;
                height: 1px;
                background: #eff0f2;
            }
            &:hover {
                .name {
                    color: var(--srt-main-active-text-color);
                }
                .iconfont {
                    color: var(--srt-main-active-text-color);
                }
            }
        }
        .app {
            &:hover {
                .qr {
                    display: flex;
                }
            }
        }
        .name {
            font-size: 12px;
            margin-top: 4px;
            margin-bottom: 14px;
            color: var(--srt-main-text-color);
            width: 48px;
            text-align: center;
        }
        .iconfont {
            font-size: 24px;
            color: var(--srt-color-light-gray);
            font-weight: bold;
        }
        .logo {
            width: 24px;
            height: 24px;
            border-radius: 6px;
            object-fit: fill;
        }
        .qr {
            align-items: center;
            padding: 12px;
            width: 212px;
            height: 104px;
            background: #ffffff;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
            position: absolute;
            right: 76px;
            bottom: 0px;
            display: none;
            transition: all 0.2s;
        }
        .qr-img {
            width: 80px;
            height: 80px;
            margin-right: 10px;
        }
        .qr-name {
            color: var(--srt-main-text-color);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 98px;
            display: inline-block;
        }

        .qr-tip {
            font-size: 12px;
            color: var(--srt-color-light-gray);
            margin-top: 14px;
            display: inline-block;
        }
    }
    &.xj-home-page {
        --nav-sub-bg-more-color: rgba(0, 137, 255, 0.84);
        --nav-sub-bg-active-color: #62f0ff;
        --nav-bg-active-color: rgba(255, 255, 255, 0.18);
        --home-color-bg: #f6f9ff;
        --home-color-bg-ligter: #f6f9ff;
        --nav-top-bg-color: #0c69fc;
        --nav-bottom-bg-color: #1cb7fe;
        --home-main-color: #0089ff;
        --home-color-bg-ligter1: #ecf2ff;
        --home-header-bg: #e3eeff;
        --home-border-color: #c9d2e5;
        --home-main-active-color: #0089ff;
        --home-header-line: #0c69fc;
        --home-header-line-lighter: #0089ff;
    }
    &.gz-home-page {
        --nav-sub-bg-more-color: rgba(0, 137, 255, 0.84);
        --nav-sub-bg-active-color: #62f0ff;
        --nav-bg-active-color: rgba(255, 255, 255, 0.18);
        --home-color-bg: #f6f9ff;
        --home-color-bg-ligter: #f7f9fa;
        --nav-top-bg-color: #0f37b8;
        --nav-bottom-bg-color: #34a8cb;
        --home-main-color: #1e3890;
        --home-color-bg-ligter1: #e9ecf4;
        --home-header-bg: #e6f0f6;
        --home-border-color: #d3dcd1;
        --home-main-active-color: #1e3890;
        --home-header-line: #0f37b8;
        --home-header-line-lighter: #30bfea;
    }
}
</style>
